/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Supporttext2Inputs */

const zh_pricing_faq5a_supporttext2 = /** @type {(inputs: Pricing_Faq5a_Supporttext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您无法访问，可以`)
};

const en_pricing_faq5a_supporttext2 = /** @type {(inputs: Pricing_Faq5a_Supporttext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you cannot access your account, you can`)
};

const es_pricing_faq5a_supporttext2 = /** @type {(inputs: Pricing_Faq5a_Supporttext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si no puedes acceder a tu cuenta, puedes`)
};

/**
* | output |
* | --- |
* | "If you cannot access your account, you can" |
*
* @param {Pricing_Faq5a_Supporttext2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_supporttext2 = /** @type {((inputs?: Pricing_Faq5a_Supporttext2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Supporttext2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_supporttext2(inputs)
	if (locale === "en") return en_pricing_faq5a_supporttext2(inputs)
	return es_pricing_faq5a_supporttext2(inputs)
});
export { pricing_faq5a_supporttext2 as "pricing_faq5A_supportText" }